namespace h5_vm {

   export class GosBasePageModel {
      onPageCommit?: Function;
   }
}
